var map = {
	"./平台-京东-置灰.png": 7038,
	"./平台-京东.png": 60329,
	"./平台-其他-置灰.png": 51826,
	"./平台-其他.png": 48965,
	"./平台-唯品会-置灰.png": 23780,
	"./平台-唯品会.png": 39527,
	"./平台-小红书-置灰.png": 299,
	"./平台-小红书.png": 96526,
	"./平台-微博-置灰.png": 20278,
	"./平台-微博.png": 6513,
	"./平台-拼多多-置灰.png": 33954,
	"./平台-拼多多.png": 78581,
	"./平台-淘宝-置灰.png": 95817,
	"./平台-淘宝.png": 6884,
	"./平台-罗麦-置灰.png": 31499,
	"./平台-罗麦.png": 48846,
	"./平台-美团-置灰.png": 8046,
	"./平台-美团.png": 49113,
	"./平台-饿了么-置灰.png": 87265,
	"./平台-饿了么.png": 620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74732;